<h1 class="table__title">Event Notifications</h1>
<div class="table__control">
  <mat-checkbox [checked]="notYetSent" (change)="notYetSent = !notYetSent;displayChange()">Show not yet sent
  </mat-checkbox>
  <mat-checkbox [checked]="alreadySent" (change)="alreadySent = !alreadySent;displayChange()">Show already sent
  </mat-checkbox>
  <mat-checkbox [checked]="trackedTasksOnly" (change)="trackedTasksOnly = !trackedTasksOnly;displayChange()">Show
    tracked tasks only
  </mat-checkbox>
  <div>
    <button *ngIf="addButton" mat-raised-button class="grey-btn" (click)="addNotification($event)">
      <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
      Notification
    </button>
  </div>
</div>
<ng-template #noDocs>
  <h4>No Event Notifications</h4>
</ng-template>
<div class="table__container">
  <table *ngIf="alerts?.length > 0;else noDocs" class="table__inner" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="Action" *ngIf="addButton">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element"><a matTooltip="Delete Event Notification"
          *ngIf="!element?.propertiesObj.AlertSendDate" (click)="delete(element)">
          <!-- <img src="assets/images/icon-cross.svg" /> -->
          <mat-icon>delete</mat-icon>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="AlertNotificationNumber">
      <th mat-header-cell *matHeaderCellDef>Seq #</th>
      <td mat-cell *matCellDef="let row;let element;">
        <a *ngIf="!element?.propertiesObj.AlertSendDate" class="alertLink"
          (click)="editNotificatoin(row)">{{ element?.propertiesObj.AlertNotificationNumber }}</a>
        <span *ngIf="element?.propertiesObj.AlertSendDate">{{ element?.propertiesObj.AlertNotificationNumber }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="AlertDueDate">
      <th mat-header-cell *matHeaderCellDef>Alert Date</th>
      <td mat-cell *matCellDef="let row;let element;">
        <a *ngIf="!element?.propertiesObj.AlertSendDate" class="alertLink"
          (click)="editNotificatoin(row)">{{ element?.propertiesObj.AlertDueDate | aspenDate }}</a>
        <span *ngIf="element?.propertiesObj.AlertSendDate">{{ element?.propertiesObj.AlertDueDate | aspenDate }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="AlertEmailAdresses">
      <th mat-header-cell *matHeaderCellDef>To</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AlertEmailAdresses }}</td>
    </ng-container>

    <ng-container matColumnDef="AlertMessageText">
      <th mat-header-cell *matHeaderCellDef>Reminder Text</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AlertMessageText }}</td>
    </ng-container>

    <ng-container matColumnDef="AlertSendDate">
      <th mat-header-cell *matHeaderCellDef>Date Sent</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AlertSendDate | aspenDate }}</td>
    </ng-container>

    <ng-container matColumnDef="AlertTrackTask">
      <th mat-header-cell *matHeaderCellDef>Track Task</th>
      <td mat-cell *matCellDef="let element"><img
          [src]="element?.propertiesObj.AlertTrackTask ? 'assets/images/icon-tick.svg' : 'assets/images/icon-cross.svg'" />
      </td>
    </ng-container>

    <ng-container matColumnDef="AlertTrackComplete">
      <th mat-header-cell *matHeaderCellDef>Task Completed</th>
      <td mat-cell *matCellDef="let element"><a (click)="completeTask(element)"><img
            [src]="element?.propertiesObj.AlertTrackComplete ? 'assets/images/icon-tick.svg' : 'assets/images/icon-cross.svg'" /></a>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div class="table__pagination">
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
